// Servicio de autenticación centralizado
// Este servicio actúa como una fachada para encapsular toda la lógica de autenticación
import { browserAuthService } from './browserAuth';
import { User } from '../types/user';

export const authService = {
  // Iniciar sesión con email y contraseña
  async login(email: string, password: string): Promise<{ user: User; token: string } | null> {
    try {
      console.log('authService: Iniciando sesión');
      const result = await browserAuthService.login(email, password);
      
      if (result) {
        // Disparar un evento personalizado para notificar que la autenticación fue exitosa
        // Esto ayuda a solucionar problemas de sincronización en la app
        const authEvent = new CustomEvent('auth:login-success', { 
          detail: { user: result.user }
        });
        window.dispatchEvent(authEvent);
        
        return result;
      }
      return null;
    } catch (error) {
      console.error('Error en servicio de autenticación (login):', error);
      return null;
    }
  },
  
  // Cerrar sesión
  async logout(): Promise<void> {
    try {
      console.log('authService: Cerrando sesión');
      browserAuthService.logout();
      
      // Disparar evento de logout
      const authEvent = new CustomEvent('auth:logout');
      window.dispatchEvent(authEvent);
      
    } catch (error) {
      console.error('Error en servicio de autenticación (logout):', error);
    }
  },
  
  // Obtener el usuario actual
  async getCurrentUser(): Promise<User | null> {
    try {
      console.log('authService: Obteniendo usuario actual');
      return await browserAuthService.getCurrentUser();
    } catch (error) {
      console.error('Error en servicio de autenticación (getCurrentUser):', error);
      return null;
    }
  },
  
  // Verificar si el token es válido
  async isTokenValid(): Promise<boolean> {
    try {
      return await browserAuthService.isTokenValid();
    } catch (error) {
      console.error('Error en servicio de autenticación (isTokenValid):', error);
      return false;
    }
  },
  
  // Forzar actualización del contexto de autenticación
  forceAuthUpdate() {
    try {
      // Disparar evento para forzar actualización
      const authEvent = new CustomEvent('auth:force-update');
      window.dispatchEvent(authEvent);
    } catch (error) {
      console.error('Error al forzar actualización de autenticación:', error);
    }
  },

  // Solicitar recuperación de contraseña
  async requestPasswordReset(email: string): Promise<string | null> {
    try {
      console.log('authService: Solicitando recuperación de contraseña para:', email);
      return await browserAuthService.generatePasswordResetToken(email);
    } catch (error) {
      console.error('Error en servicio de autenticación (requestPasswordReset):', error);
      return null;
    }
  },

  // Validar token de recuperación
  async validatePasswordResetToken(token: string): Promise<string | null> {
    try {
      console.log('authService: Validando token de recuperación');
      return await browserAuthService.validatePasswordResetToken(token);
    } catch (error) {
      console.error('Error en servicio de autenticación (validatePasswordResetToken):', error);
      return null;
    }
  },

  // Restablecer contraseña con token
  async resetPasswordWithToken(token: string, newPassword: string): Promise<boolean> {
    try {
      console.log('authService: Restableciendo contraseña con token');
      return await browserAuthService.resetPasswordWithToken(token, newPassword);
    } catch (error) {
      console.error('Error en servicio de autenticación (resetPasswordWithToken):', error);
      return false;
    }
  }
};

export default authService;
